import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, Plus, Tag, User, Wrench } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import authStore from '../../store/authStore';

const TabBar = () => {
  const location = useLocation();
  const { user } = authStore();
  const { t } = useTranslation();

  const hiddenPaths = ['/login', '/register', '/verify-email', '/admin'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;
  if (location.pathname === '/' && !user) return null;

  const tabs = [
    { path: '/', icon: Home, label: t('Home') },
    { path: '/services', icon: Wrench, label: t('Servizi') },
    { path: '/create', icon: Plus, label: t('Pubblica'), special: true },
    { path: '/search', icon: Search, label: t('Cerca') },
    { path: '/profile', icon: User, label: t('Profilo') },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-testid="tab-bar">
      <div className="bg-[#1E293B] flex items-end justify-around h-16 px-2 pb-1 pt-2">
        {tabs.map((tab) => {
          const isActive = tab.path === '/' 
            ? location.pathname === '/' 
            : location.pathname.startsWith(tab.path);
          const Icon = tab.icon;

          if (tab.special) {
            return (
              <Link
                key={tab.path}
                to={user ? tab.path : '/login'}
                className="flex flex-col items-center -mt-5"
                data-testid="tab-create"
              >
                <div className="w-[52px] h-[52px] rounded-full bg-[#10B981] flex items-center justify-center shadow-lg shadow-emerald-500/30">
                  <Icon className="w-7 h-7 text-white" strokeWidth={2.5} />
                </div>
              </Link>
            );
          }

          return (
            <Link
              key={tab.path}
              to={tab.path === '/profile' && !user ? '/login' : tab.path}
              className="flex flex-col items-center justify-center flex-1 py-1"
              data-testid={`tab-${tab.label.toLowerCase()}`}
            >
              <Icon
                className={`w-6 h-6 ${isActive ? 'text-[#10B981]' : 'text-slate-400'}`}
                strokeWidth={isActive ? 2.5 : 1.5}
              />
              <span className={`text-[11px] mt-1 font-semibold ${isActive ? 'text-[#10B981]' : 'text-slate-400'}`}>
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default TabBar;
